import { FaClock, FaGlobe, FaHeadset, FaShieldHalved } from 'react-icons/fa6'
import AnimatedSection from '../common/AnimatedSection'
import { contactWhySection } from '../../data/contactPageData'

const whyIcons = {
  clock: FaClock,
  globe: FaGlobe,
  shield: FaShieldHalved,
  headset: FaHeadset,
}

function ContactWhySection() {
  const { titleLine1, titleAccent, items } = contactWhySection

  return (
    <AnimatedSection className="contact-why">
      <div className="container corp-container">
        <header className="contact-why__head">
          <h2>
            {titleLine1} <span>{titleAccent}</span>
          </h2>
          <span className="contact-why__accent" aria-hidden="true" />
        </header>

        <div className="contact-why__grid" role="list">
          {items.map((item) => {
            const Icon = whyIcons[item.icon]
            return (
              <article
                className="contact-why__card"
                key={item.id}
                role="listitem"
              >
                <span
                  className={`contact-why__icon contact-why__icon--${item.variant}`}
                  aria-hidden="true"
                >
                  <Icon />
                </span>
                <div className="contact-why__card-body">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ContactWhySection
